export enum BundleReturnMode {
  ALWAYS_TOGETHER = "always_together",
  ALWAYS_SEPARATE = "always_separate",
  CUSTOMER_CHOICE = "customer_choice",
}

// Line-item-scoped key: two line items can share a variant id (e.g. an upsell),
// so keying bundle parents by variant id alone would collapse them into one.
export function bundleParentKey(
  lineItemId: string,
  parentVariantId: string,
): string {
  return `${lineItemId}::${parentVariantId}`;
}
